import { createSelector } from 'reselect';

import { IUserProfileState } from './reducer';

export const selectUserProfile = (state: any): IUserProfileState => {
  return state.userProfile;
};

export const getUserEmail = createSelector(
  selectUserProfile,
  userProfileState => {
    return userProfileState.userInfo!.email;
  },
);

export const getUserId = createSelector(
  selectUserProfile,
  userProfileState => {
    return userProfileState.userInfo!.id;
  },
);

export const getUserProfile = createSelector(
  selectUserProfile,
  userProfileState => {
    return userProfileState;
  },
);

export const getUserProfileInfo = createSelector(
  selectUserProfile,
  userProfileState => {
    return userProfileState.userInfo!;
  },
);

export const getExpectedWordsCount = createSelector(
  selectUserProfile,
  userProfile => {
    return userProfile.settings.wordsGoal;
  },
);

export const getSubscriptionsState = createSelector(
  selectUserProfile,
  userProfile => {
    if (userProfile.userInfo) {
      return userProfile.userInfo.subscription;
    }

    return null;
  },
);

export const getUserNotices = createSelector(
  selectUserProfile,
  userProfile => {
    return userProfile.notices;
  },
);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/selectors.ts